import React from "react";

const OXCancel = ({ close }) => {
  return (
    <div className="mr-6 mt-6">
      <div className="flex justify-end">
        <p onClick={close} className="cursor-pointer border-[#000] border-[1.5px] rounded-full h-6 w-6 flex items-center justify-center">
          <i className="fa-solid fa-xmark text-[14px] text-gray"></i>{" "}
        </p>
      </div>
    </div>
  );
};

export default OXCancel;
